<template src="../../public/theme/base/timeline.html"></template>

<script>
import moment from 'moment'

export default {
  name: 'timelineComponent',
  props: ['start', 'end'],
  computed: {
    endYear() {
      return moment(this.end).year()
    },
    startYear() {
      return moment(this.start).year()
    },
    startTooltip() {
      return moment(this.start).format('MMMM Do')
    },
    endTooltip() {
      return moment(this.end).format('MMMM Do')
    },
  },
}
</script>

<style lang="scss" scoped>
// .tag {
//   color: white;
//   background-color: hsl(217, 45%, 45%);

//   &:hover {
//     background-color: hsl(217, 40%, 40%);
//   }
// }
</style>
